import React from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import { useSpring } from 'react-spring';
import * as Ui from './styles';
import uploadUrl from '../../../assets/images/upload-new.svg';

export default function Dropzone({ file, onAcceptFile, progress, disabled, hasError = false, onClearError, compact = false }) {
  // handle rejected files
  function handleDropRejectedFile(rejectedFiles) {
    if (rejectedFiles && rejectedFiles.length > 0) {
      const rejected = rejectedFiles[0];
      const fileType = rejected?.type || rejected?.file?.type;
      if (fileType) {
        const ext = fileType.split('/');
        toast.error(`A extensão ${ext[1] || 'desconhecida'} não é suportada, tente um arquivo .CSV`);
      } else {
        toast.error('Formato de arquivo não suportado, tente um arquivo .CSV');
      }
    } else {
      toast.error('Formato de arquivo não suportado, tente um arquivo .CSV');
    }
  }

  // handle accepted files
  function handleDropAcceptedFile(acceptedFile) {
    if (onAcceptFile) onAcceptFile(acceptedFile);

    if (acceptedFile && onClearError) {
      onClearError(); // limpa o erro quando novo arquivo é selecionado
    }
  }

  // handle remove files
  function handleRemoveFile() {
    handleDropAcceptedFile(null);
  }

  // configuring dropzone props
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    open
  } = useDropzone({
    minSize: 0,
    multiple: false,
    accept: '.csv, text/csv, application/vnd.ms-excel, application/csv, text/plain',
    onDropAccepted: handleDropAcceptedFile,
    onDropRejected: handleDropRejectedFile,
  });

  // FIXME: resolver pois não está funcionando corretamente
  // animation TODO: não entendi de onde é a animação
  const animation = useSpring({
    from: {
      marginTop: -10,
      opacity: 0,
      height: 0,
      visibility: 'hidden',
    },
    to: {
      opacity: file ? 1 : 0,
      height: file ? 74 : 0,
      visibility: file ? 'visible' : 'hidden',
    },
  });

  // Determina se irá renderizar o icone de exclusão ou o de substituição de arquivo
  const renderFileInputIcon = () => {
    if (hasError) {
      return (
        <Ui.ReplaceFileWrapper
          role="button"
          onClick={() => open()}
        >
          <Ui.ReplaceFileText>Substituir arquivo</Ui.ReplaceFileText>
        </Ui.ReplaceFileWrapper>
      )
    } else {
      return (
        <div className="action">
          <div
            tabIndex={-999}
            role="button"
            className="wrapperImage"
            onClick={() => handleRemoveFile()}
          >
            <Ui.CloseButton size={15} color="#FFF" />
          </div>
        </div>
      )
    }
  }

return (
  <Ui.Upload compact={compact}>

    <input {...getInputProps()} name="arquivo" style={{ display: 'none' }} />

    {!file ? (
      <Ui.DragDrop
        compact={compact}
        {...getRootProps({
          isDragActive,
          isDragAccept,
          isDragReject,
        })}
      >
        <Ui.Image compact={compact}>
          <img src={uploadUrl} alt="upload" />
        </Ui.Image>
        <h3>
          Arraste e solte aqui uma avaliação
        </h3>
        <p>
          Você também pode <span>procurar no seu computador</span>
        </p>
      </Ui.DragDrop>
    ) : (
      <Ui.ListFiles style={animation}>
        <Ui.File key={file.name} progress={progress} hasError={hasError}>
          <div className="info">
            <h4>{file.name}</h4>
            <span>
              {hasError
                ? 'Carregamento em 100%'
                : progress > 0
                  ? `Carregamento em ${progress}%`
                  : 'Arquivo selecionado'}
            </span>
          </div>
          {!disabled ? renderFileInputIcon() : ''}
        </Ui.File>
      </Ui.ListFiles>
    )}
  </Ui.Upload>
);
}
